export const types_of_site_options = [
  { heading: 'E-Commerce (Online store)', stateValue: 'ECommerce' },
  { heading: 'Blog', stateValue: 'Blog' },
  { heading: 'Portfolio', stateValue: 'Portfolio' },
  { heading: 'Educational/Informational', stateValue: 'Informational' },
];

export const intended_audience_options = [
  { heading: 'Adults', stateValue: 'Adults' },
  { heading: 'Teenagers', stateValue: 'Teenagers' },
  { heading: 'Children', stateValue: 'Children' },
];
